import React from "react";
import "./MenuItemModal.css";

export default function MenuItemModal({ item, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-left">
          <img src={item.imageUrl || "https://via.placeholder.com/600x400"} alt={item.name} />
        </div>
        <div className="modal-right">
          <h2>{item.name}</h2>
          <p className="muted">{item.description}</p>
          <h3>${item.price?.toFixed(2)}</h3>
          <div className="modal-tags">
            {item.tags?.map((t) => <span key={t} className="tag">{t}</span>)}
          </div>
          <div style={{ marginTop: 20 }}>
            <button onClick={onClose} className="menu-close">Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}
